<template>
  <tr :class="{ 'cursor-pointer': canOpenReservation }">
    <td>
      <reservation-state-icon :state="reservation.state" />
    </td>

    <td>{{ reservation.ar_external_id }}</td>

    <td>{{ reservation.ar_created_at }}</td>

    <td>{{ reservation.ar_acceptance_date }}</td>

    <td>{{ reservation.installation_deadline }}</td>

    <td>{{ reservation.ar_installation_date }}</td>

    <td>{{ reservation.ar_current_end_date }}</td>
  </tr>
</template>

<script>
import ReservationStateIcon from "@/components/AssetReservationManagement/Data/StateIcon";

export default {
  name: "ReservationsTableRow",

  components: { ReservationStateIcon },

  props: {
    /**
     * Receives the reservation
     */
    reservation: {
      type: Object,
      required: true
    },

    /**
     * Determines if the user can open reservation
     */
    canOpenReservation: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/ReservationsTableRow.vue